export default __webpack_public_path__ + "static/media/offers.293832db.svg";